import {  HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseUserService } from '../../base/services/base-user.service';
import { WeatherDetailsResponse } from '../models/weather-details';
import { WeatherForecastDetailsResponse } from '../models/forecast-details';
@Injectable({
  providedIn: 'root',
})
export class WeatherService extends BaseUserService {
  constructor( ) {
    super();
  }
  getWeatherDetails(lat:number,lon:number):Observable<WeatherDetailsResponse>{
   let params = new HttpParams()
   .set('lat', lat)
   .set('lon', lon)
   
    const url =this.env.externalUrls.product.baseUrl+'geo/weather';
    return this.http.get<WeatherDetailsResponse>(url,{params})
  }
 getForecast(lat:number,lon:number):Observable<WeatherForecastDetailsResponse>{
  let params =new HttpParams()
  .set('lat',lat)
  .set('lon',lon)
  const url =this.env.externalUrls.product.baseUrl+'geo/forecast';
  return this.http.get<WeatherForecastDetailsResponse>(url,{params})

 }
}
